import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/region/importer/regionImporterActions';

export default importerReducers(actions);
